<template>
  <div id="promotions-add-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title" :maxlength="100" show-word-limit></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.stock") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.stockMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input-number v-model="form.stock" :min="1"></el-input-number>
                <span class="error">{{ $errorMessage("stock", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.note") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.noteMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <quill-editor :options="editorOption" ref="myQuillEditor" @ready="onEditorReady" v-model="form.brief" />
                <span class="error">{{ $errorMessage("brief", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-2">
            <el-col :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="form.enableLimitations = !form.enableLimitations">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.limitations") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.limitationsMsg") }}</span>
                  </div>
                  <div class="section-switch" @click.stop>
                    <el-switch v-model="form.enableLimitations"></el-switch>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="form.enableLimitations">
                    <div class="custom-groups-list mt-2">
                      <div class="custom-groups-list-item" v-for="item in $store.state.groups.items" :key="item.id + '-tag-group-id'">
                        <div class="custom-groups-list-item-head" @click="item.show = !item.show">
                          <div class="custom-groups-list-item-head-title">
                            <span>
                              <i class="fas fa-square mr-2" :style="'color:' + item.color"></i>
                              {{ item.title }}
                            </span>
                            <span class="counter-badge" v-if="item.tags.filter(x => form.tags.some(y => y == x.id)).length > 0 ? true : false">{{ item.tags.filter(x => form.tags.some(y => y == x.id)).length }}</span>

                            <i class="fas fa-chevron-down" :class="{ active: item.show }"></i>
                          </div>
                          <el-button size="mini" type="primary" icon="fas fa-check" round @click.stop="selectAll(item.tags)">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.selectAll") }}</el-button>
                        </div>
                        <transition name="el-zoom-in-top" mode="out-in">
                          <div class="custom-groups-list-item-tags" v-if="item.show">
                            <div class="customg-group-tag-item" v-for="tagItem in item.tags" :key="tagItem.id" @click="toggleTag(tagItem.id)" :class="{ active: form.tags.some(x => x == tagItem.id) }">
                              <div class="customg-group-tag-item-title">
                                <div class="tag-color-circle" :style="{ backgroundColor: tagItem.color }"></div>
                                <span>
                                  {{ tagItem.title }}
                                </span>
                              </div>

                              <i class="fas fa-check"></i>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </div>
                    <!-- <el-collapse accordion class="tagfilter-collapse">
                      <el-collapse-item v-for="group in $store.state.groups.items" :key="group.id + 'group-item'">
                        <template slot="title" v-if="group">
                          <div class="tagfilter-title" style="    line-height: 16px; padding: 16px 0 16px 0">
                            <i class="fas fa-square" :style="{ color: group.color }"></i> {{ group.title }} <span v-if="group.tags.length > 0 && form.tags.length > 0">{{ group.tags.filter((x) => form.tags.some((y) => x.id === y)).length }}</span>
                          </div>
                        </template>
                        <div class="group-tags-container">
                          <template v-if="group.tags.length > 0">
                            <div class="tag-item" :class="{ active: form.tags.some((x) => x == tag.id) ? true : false }" v-for="(tag, index) in group.tags" :key="index + 'tagitem'" @click="tagAdd(tag.id)">
                              <i class="fas fa-circle" :style="{ color: tag.color }"></i>
                              <span>{{ tag.title }} </span>
                              <b><i class="fas fa-check"></i></b>
                            </div>
                          </template>
                          <el-alert :closable="false" v-else type="info" class="w-100" :show-icon="true">{{ $t("onsiteUtilities.promotions.promotionAddUpdate.limitationsNotFound") }}</el-alert>
                        </div>
                      </el-collapse-item>
                    </el-collapse> -->
                  </div>
                </transition>
              </div>

              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("onsiteUtilities.promotions.promotionAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("onsiteUtilities.promotions.promotionAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="!(loading == 'updateScreenLoading' && form == null)">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("onsiteUtilities.promotions.promotionAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("onsiteUtilities.promotions.promotionAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("onsiteUtilities.promotions.promotionAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";
import { quillEditor } from "vue-quill-editor";
export default {
  components: { ItemInfo, quillEditor },
  name: "SubEventAddUpdate",
  props: ["id"],

  data() {
    return {
      loading: false,
      timeout: null,
      form: null,
      settingsDock: false,
      limitationsDock: false,
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ color: [] }], ["clean"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },

      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      moment
    };
  },
  methods: {
    toggleTag(id) {
      var fIndex = this.form.tags.findIndex(x => x == id);
      if (fIndex != -1) {
        this.form.tags.splice(fIndex, 1);
      } else {
        this.form.tags.push(id);
      }
    },
    selectAll(tags) {
      tags.forEach(x => {
        var fIndex = this.form.tags.findIndex(y => y == x.id);
        if (fIndex == -1) {
          this.form.tags.push(x.id);
        }
      });
    },
    // selectCounter(id) {
    //   var countt = 0;
    //   this.$store.state.groups.items.find(x => x.id == id).tags.forEach((item, index) => {
    //     if (item.id == this.form.tags[index])
    //     {
    //       countt += 1
    //     }
    //   });
    //   return countt
    // },
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    selectLocalImage() {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file);
        } else {
          console.warn("You could only upload images.");
        }
      };
    },
    saveToServer(file) {
      const fd = new FormData();
      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url);
          } else {
            this.$message.error(body.alert.message);
          }
        }
      };

      xhr.send(fd);
    },
    insertToEditor(url) {
      const range = this.$refs.myQuillEditor.quill.getSelection();
      this.$refs.myQuillEditor.quill.insertEmbed(range.index, "image", `${url}`);
    },
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("promotion/addorupdate", { ...this.form });
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          this.form = res.data.data.item;
          await this.$store.dispatch("getPromotions");
        }
        this.loading = false;
      }, 500);
    },
    tagAdd(id) {
      if (this.form.tags.some(x => x == id)) {
        var cIndex = this.form.tags.findIndex(x => x == id);
        this.form.tags.splice(cIndex, 1);
      } else {
        this.form.tags.push(id);
      }
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(timeout);
    this.timeout = setTimeout(async () => {
      if (this.id != undefined && this.id != null) {
        var res = await this.$store.dispatch("getPromotionOneItem", this.id);
        this.$store.dispatch("getGroups");
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit("closeDialog");
        }
      } else {
        this.form = {
          id: null,
          title: null,
          stock: 1,
          brief: null,
          isActive: true,
          enableLimitations: false,
          tags: []
        };
      }
    }, 500);
  },
  async mounted() {
    await this.$store.dispatch("getVenues");
  },
  computed: {}
};
</script>

<!-- <style>
#venue-add-update .el-checkbox-button {
  margin: 2px;
  width: 200px;
  border: none !important;
}

#venue-add-update .el-checkbox-button__inner {
  width: 200px;
  border: none !important;
  border: 1px solid #ddd !important;
  border-radius: 3px !important;
}

#venue-add-update .el-checkbox-button.is-checked .el-checkbox-button__inner {
  border-color: transparent !important;
}

#venue-add-update .el-checkbox-group {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
</style> -->
<style lang="less" scoped>
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.mage-maker {
  width: 100%;
  position: relative;
  border: 1px dashed #ccc;
  height: 250px;
  background-size: contain !important;
  background-position: center center !important;
  border-radius: 5px;
  background-repeat: no-repeat !important;
  .avatar-uploader {
    opacity: 0;
    transition: all 1s;
    &:hover {
      opacity: 1 !important;
    }
    & > .el-upload {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.group-btn-container {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  align-items: center;

  .el-button {
    padding: 4px;
    margin-left: 0;
  }
  i.el-icon-info {
    font-size: 24px;
  }
}
.model-base-small {
  min-width: 500px;
}
.switch-btn-container {
  display: flex;
  .el-button {
    flex-grow: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PromotionAddUpdate.vue